import React, { useState, useEffect } from "react";

import App from "../../App";
import { LogoImg, PwBackground, PwForm, PwSubmit, Pwinput } from "./AppPwProtected.elements";
import { GlobalStyles } from "../../GlobalStyles.styles";


import {
  MdOutlineArrowBackIosNew,
  MdOutlineArrowForwardIos,
} from "react-icons/md";

function PasswordProtection() {
  const [password, setPassword] = useState("5500sim!");
  const [isValid, setIsValid] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [shakeInput, setShakeInput] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue === password) {
      setIsValid(true);
    } else {
      setShakeInput(true);

      setInputValue("");
    }
  };

  const handleAnimationEnd = () => {
    setShakeInput(false);
  };

  if (isValid) {
    return <App />;
  }

  return (
    <PwBackground>
      {/* <LogoImg src={logo}/> */}
      <PwForm
        onSubmit={handleSubmit}
        shake={shakeInput}
        onAnimationEnd={handleAnimationEnd}
      >
        <label>
          <Pwinput
            type="password"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            // className={isWrongPassword ? "wrong" : ""}
          />
        </label>
        <PwSubmit type="submit">
          <MdOutlineArrowForwardIos />
        </PwSubmit>
      </PwForm>
    </PwBackground>
  );
}

function AppPwProtected() {
  return (
    <>
      <GlobalStyles />
      <PasswordProtection />
    </>
  );
}

export default AppPwProtected;
